import { render, staticRenderFns } from "./siderNav.vue?vue&type=template&id=6ca89474&scoped=true&"
import script from "./siderNav.vue?vue&type=script&lang=js&"
export * from "./siderNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca89474",
  null
  
)

export default component.exports